import { useState } from "react";

const useVariationsFilter = () => {
  const [filter, setFilter] = useState({});

  const onFilterChange = (data) => {
    setFilter((state) => {
      const newState = { ...state };
      if (data.value == null) {
        if (state[data.id] != null) {
          delete newState[data.id];
        } else {
          return state;
        }
      } else {
        if (state[data.id] !== data.value) {
          newState[data.id] = data.value;
        } else {
          return state;
        }
      }
      return newState;
    });
  };

  const getFilteredVariations = (variations) => {
    const filteredVariations = variations?.filter((variation) => {
      const filteredParameters = variation.parameters.filter((parameter) => {
        if (filter[Object.keys(parameter)[0].toUpperCase()] == null) {
          return true;
        }
        return (
          Object.values(parameter)[0].toString() ===
          filter[Object.keys(parameter)[0].toUpperCase()].toString()
        );
      });
      return variation?.parameters?.length === filteredParameters?.length;
    });
    return filteredVariations;
  }

  return { onFilterChange, getFilteredVariations };
};

export default useVariationsFilter;
